export enum AmbienteAcesso {
    Amigavel = 1,
    Juridico = 2,
}

export const AmbienteAcessoLabel = new Map<AmbienteAcesso, string>([
    [AmbienteAcesso.Amigavel, "Amigável"],
    [AmbienteAcesso.Juridico, "Jurídico"],
]);
